const normalizeStockAdjustmentSearch = (value) =>
  String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

const getProductName = (product = {}) =>
  product.name || product.nom_produit || `Produit ${product.id || ""}`.trim();

const getVariantChoiceLabel = (product = {}) =>
  product.variant_label || getProductName(product);

const buildOption = (product = {}) => {
  const productName = getProductName(product);
  const parentName = product.parent_name || null;
  const variantLabel = getVariantChoiceLabel(product);
  const selectedLabel = parentName
    ? `${parentName} — ${variantLabel}`
    : productName;

  return {
    value: product.id,
    product,
    productName,
    parentName,
    variantLabel,
    selectedLabel,
    itemCode: product.item_code || null,
    currentStock: Number(product.current_stock) || 0,
    searchText: [
      parentName,
      product.parent_item_code,
      product.parent_barcode_value,
      productName,
      variantLabel,
      product.item_code,
      product.barcode_value,
      product.barcode,
    ]
      .filter(Boolean)
      .join(" "),
  };
};

const buildStockAdjustmentProductOptions = (products = []) => {
  const standaloneOptions = [];
  const variantGroupMap = new Map();

  for (const product of Array.isArray(products) ? products : []) {
    if (
      !product?.id ||
      product.is_variant_parent === true ||
      Number(product.is_variant_parent) === 1
    ) {
      continue;
    }

    const option = buildOption(product);
    const parentId = Number(product.parent_product_id) || null;

    if (!parentId) {
      standaloneOptions.push(option);
      continue;
    }

    if (!variantGroupMap.has(parentId)) {
      variantGroupMap.set(parentId, {
        parentId,
        parentName: product.parent_name || "Produit à variantes",
        parentItemCode: product.parent_item_code || null,
        stockTotal: 0,
        options: [],
      });
    }

    const group = variantGroupMap.get(parentId);
    group.stockTotal += option.currentStock;
    group.options.push(option);
  }

  const variantGroups = [...variantGroupMap.values()];
  return {
    standaloneOptions,
    variantGroups,
    flatOptions: [
      ...standaloneOptions,
      ...variantGroups.flatMap((group) => group.options),
    ],
  };
};

const matchesStockAdjustmentOption = (input, optionSearchText) =>
  normalizeStockAdjustmentSearch(optionSearchText).includes(
    normalizeStockAdjustmentSearch(input)
  );

module.exports = {
  buildStockAdjustmentProductOptions,
  matchesStockAdjustmentOption,
  normalizeStockAdjustmentSearch,
};
